export const templates = `query {
    templates {
        kmatID
        name
      }
  }`
